/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Dialog_CancelInputs */

const vi_einvoice_dialog_cancel = /** @type {(inputs: Einvoice_Dialog_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huỷ`)
};

/**

* @param {Einvoice_Dialog_CancelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_dialog_cancel = /** @type {((inputs?: Einvoice_Dialog_CancelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Dialog_CancelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_dialog_cancel(inputs)
});